// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"0a9dbe54","690":"127b438c"}[chunkId] + ".css";
};